module.exports = __webpack_public_path__ + "static/media/double-dollar-fugue.0bc746db.png";